import { useEffect } from 'react'

import { useAuth } from '@/features/auth/auth-context'
import { mountSupportWidget, unmountSupportWidget } from '@/shared/widget/support-widget'

export function SupportWidgetBootstrap() {
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) {
      unmountSupportWidget()
      return
    }

    void mountSupportWidget()
  }, [isAuthenticated])

  useEffect(() => () => unmountSupportWidget(), [])

  return null
}
